<template>
  <div class="app-wrapper" :class="{ 'mobile': device === 'mobile' }">
    <!-- 侧边栏遮罩（移动端） -->
    <div v-if="device === 'mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutside" />

    <!-- 侧边栏 -->
    <sidebar class="sidebar-container" />

    <!-- 主内容区 -->
    <div class="main-container" :class="{ 'has-no-sidebar': !sidebar.opened }">
      <!-- 顶部导航 -->
      <div class="fixed-header">
        <navbar />
        <tags-view />
      </div>

      <!-- 页面内容 -->
      <app-main />
    </div>
  </div>
</template>

<script>
import Sidebar from './components/Sidebar/index.vue'
import Navbar from './components/Navbar.vue'
import AppMain from './components/AppMain.vue'
import TagsView from './components/TagsView/index.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Layout',
  components: { Sidebar, Navbar, AppMain, TagsView },
  computed: {
    ...mapGetters(['sidebar', 'device'])
  },
  methods: {
    ...mapActions({ closeSideBar: 'settings/closeSideBar' }),
    handleClickOutside() {
      this.closeSideBar({ withoutAnimation: false })
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/sidebar.scss';

.app-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;

  .drawer-bg {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.3;
    z-index: 999;
  }

    .main-container {
      height: 100vh;
      transition: margin-left 0.3s;
      margin-left: 210px;
      position: relative;
      flex: 1;
      overflow-x: hidden;

      &.has-no-sidebar {
        margin-left: 64px;
        .fixed-header { left: 64px; }
      }

      .fixed-header {
        position: fixed;
        top: 0;
        right: 0;
        left: 210px;
        z-index: 9;
        transition: left 0.3s;
      }
    }
}
</style>
